module.exports = __webpack_public_path__ + "img/atendimento_saude_mask.e2af762e.svg";